/**
 * Minimalist template engine
 *
 * @example
 * template('Hello {{thing}}!', { thing: 'world' });
 *
 * @param {String} template - The template string
 * @param {Array|Object} data - Data to use in template
 * @returns {String}
 */
export default function template(template, data) {
    for (let p in data) {
        template = template.replace(new RegExp('{{'+ p +'}}', 'g'), data[p]);
    }

    return template;
}
